// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"CreateFluxBody_MainContainer__15Y0l","ButtonGroup":"CreateFluxBody_ButtonGroup__1-YYS"};